import { render, staticRenderFns } from "./form_check.vue?vue&type=template&id=10ba386e&"
import script from "./form_check.vue?vue&type=script&lang=js&"
export * from "./form_check.vue?vue&type=script&lang=js&"
import style0 from "./form_check.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports